import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

export interface AdminEmail {
  id: string;
  name: string | null;
  email: string;
  status: "ACTIVE" | "INACTIVE";
  created_at: string;
  updated_at: string;
}

export const adminEmailService = {
  // Get all admin emails
  getAllEmails: async (): Promise<AdminEmail[]> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BACKEND_URL}/admin-email/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  },

  // Get active admin emails only
  getActiveEmails: async (): Promise<AdminEmail[]> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BACKEND_URL}/admin-email/active`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  },

  // Get admin email by ID
  getEmailById: async (id: string): Promise<AdminEmail> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${BACKEND_URL}/admin-email/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  },

  // Create new admin email
  createEmail: async (name: string, email: string): Promise<AdminEmail> => {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${BACKEND_URL}/admin-email/`,
      { name, email },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.data;
  },

  // Update admin email
  updateEmail: async (id: string, name?: string, email?: string): Promise<AdminEmail> => {
    const token = localStorage.getItem("token");
    const response = await axios.put(
      `${BACKEND_URL}/admin-email/${id}`,
      { name, email },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.data;
  },

  // Update admin email status
  updateStatus: async (id: string, status: "ACTIVE" | "INACTIVE"): Promise<AdminEmail> => {
    const token = localStorage.getItem("token");
    const response = await axios.patch(
      `${BACKEND_URL}/admin-email/${id}/status`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.data;
  },

  // Delete admin email
  deleteEmail: async (id: string): Promise<void> => {
    const token = localStorage.getItem("token");
    await axios.delete(`${BACKEND_URL}/admin-email/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
